/* eslint-disable */
import React from 'react';
import {Layout} from "antd";
import FormSearch from './components/FormSearch';
import ListInventory from './components/ListPackage';
const {Content} = Layout;

class InventoryDetailContainer extends React.PureComponent {
    render() {
        return (
            <Layout>
                <Content className="a-content a-content--page-list">
                    <FormSearch/>
                    <ListInventory/>
                </Content>
            </Layout>

        )
    }
}

export default InventoryDetailContainer;